export default __webpack_public_path__ + "static/media/cp_legov.c10ae29b.png";